import * as _ from 'lodash';

import { ApplicationConfig } from '../../shared/applicationConfig';
import { ApplicationConstants } from '../../shared/applicationConstants';
import { SharedService } from '../../shared/services/sharedService';
import { AuthService } from '../../login/services/authService.js';
import * as queryString from 'query-string';

export class PerfilService {
    static defaultGallerySortConcept = 'dataPublicacio';

    static getAllElements() {
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.getAllMapsByUserUrl, { uid: uid, token: token });
    }

    static getUser(){
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.getUserSimpleUrl, { uid: uid, token: token });
    }

    static getAllApps(perfil){
        return ApplicationConstants.perfilConfig[perfil];
    }

    static getUserApps(){
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        let url = ApplicationConstants.getConfiguradesUser;
        url += queryString.stringify({codiUsuari: uid, token: token });
        url = encodeURIComponent(url);
        return SharedService.httpGet(ApplicationConstants.proxy_betterWMS + "url="+ url);
    }

    static getElements(elements, pageNumber, textToFilter, currentSortConcept, currentOrder, selectedSortConcept, paginating, sorting) {
        let result = _.cloneDeep(elements);
        let numPages = 1;
        const sortOrder = PerfilService.getCurrentOrder(currentSortConcept, currentOrder, selectedSortConcept, sorting);
        result = _.orderBy(result, selectedSortConcept, sortOrder);

        if (textToFilter && textToFilter.length >= ApplicationConfig.minCharsToFilterText) {
            result = PerfilService.filterElements(textToFilter, result);
        }

        numPages = PerfilService.totalPagesNumber(result);
        if (paginating) {
            if (pageNumber > numPages) {
                pageNumber = numPages;
            }
        } else {
            pageNumber = 1;
        }

        const numElements = result.length;
        result = PerfilService.pageElements(result, pageNumber);

        return {
            numPages,
            currentPage: pageNumber,
            numElements,
            elements: result,
            currentSortConcept: selectedSortConcept,
            currentOrder: sortOrder,
        };
    }

    static filterElements(textToFilter, elements) {
        return elements.filter((item) => {
            return (item && item.nomAplicacio && item.nomAplicacio.toLowerCase().indexOf(textToFilter.toLowerCase()) > -1) ||
                (item && item.description && item.description.toLowerCase().indexOf(textToFilter.toLowerCase()) > -1);
        });
    }

    static getCurrentOrder(currentSortConcept, currentOrder, selectedSortConcept, sorting) {
        if (sorting) {
            if (currentSortConcept === selectedSortConcept) {
                return currentOrder === ApplicationConstants.ascendingOrder
                    ? ApplicationConstants.descendingOrder
                    : ApplicationConstants.ascendingOrder;
            }

            return ApplicationConfig.defaultSortOrder;
        }

        return currentOrder;
    }

    static totalPagesNumber(elements) {
        return elements
            ? Math.ceil(elements.length / ApplicationConfig.galleryElementsPerPage)
            : 0;
    }

    static pageElements(elements, pageNumber) {
        const sliced = elements.slice((pageNumber - 1) * ApplicationConfig.galleryElementsPerPage);
        return _.take(sliced, ApplicationConfig.galleryElementsPerPage);
    }

    static getMapesDerivats() {
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.getAllMapsDerivatsByUser, { uid: uid, token: token });
    }

    static countMapesDerivats() {
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.countMapsDerivatsByUser, { uid: uid, token: token });
    }

    static countMapesHeretats() {
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.countMapsHeretatsByUser, { uid: uid, token: token });
    }

    static getMapesHeretats() {
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.getAllMapsHeretatsByUser, { uid: uid, token: token });
    }
}



// WEBPACK FOOTER //
// ./src/perfil/services/perfilService.js